import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'xt-portal-auto-logout',
  templateUrl: './auto-logout.component.html',
  styleUrls: ['./auto-logout.component.scss'],
})
export class AutoLogoutComponent implements OnInit {
  countdown = 30;

  ngOnInit(): void {
    setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      }
    }, 1000);
  }
}
